import { gql } from '@apollo/client';

export const fetchAuditNoteAuthors = gql`
  query fetchAuditNoteAuthors($searchParams: CommerceNoteSearchParams, $searchOptions: ConnectionSearchOptions) {
    auditNotes(searchParams: $searchParams, searchOptions: $searchOptions) {
      nodes {
        id
        author
        contactKey
      }
    }
  }
`;
